export type MapZoomBand = 'FAR' | 'MEDIUM' | 'CLOSE';

export const FAR_DETAIL_MAX_ZOOM = 12;
export const CLOSE_DETAIL_MIN_ZOOM = 15;

export function mapZoom(map: any, fallback = CLOSE_DETAIL_MIN_ZOOM): number {
  const zoom = Number(map?.getZoom?.());
  return Number.isFinite(zoom) ? zoom : fallback;
}

export function mapZoomBand(zoom: number): MapZoomBand {
  if (zoom <= FAR_DETAIL_MAX_ZOOM) return 'FAR';
  if (zoom < CLOSE_DETAIL_MIN_ZOOM) return 'MEDIUM';
  return 'CLOSE';
}


export function zoomInterpolate(
  zoom: number,
  farValue: number,
  closeValue: number,
  startZoom = FAR_DETAIL_MAX_ZOOM,
  endZoom = 18
): number {
  if (!Number.isFinite(zoom) || endZoom <= startZoom) return closeValue;
  const progress = Math.min(1, Math.max(0, (zoom - startZoom) / (endZoom - startZoom)));
  return farValue + (closeValue - farValue) * progress;
}
